import React from 'react'
import SetTranscriptStatusPromiseModalView from './SetTranscriptStatusPromiseModalView'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SetTranscriptStatusPromiseModal = (props: any): React.ReactElement => <SetTranscriptStatusPromiseModalView {...props} />

export default SetTranscriptStatusPromiseModal
